import { useEffect, useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { notificationAPI } from '@/lib/api';
import { toast } from 'sonner';

export default function PushNotificationManager() {
  const { user } = useAuth();
  const registered = useRef(false);

  useEffect(() => {
    if (!user || registered.current) return;

    const registerPush = async () => {
      try {
        const { requestNotificationPermission } = await import('@/lib/firebase');
        const token = await requestNotificationPermission();
        if (token) {
          await notificationAPI.registerDevice(token);
          registered.current = true;
        }
      } catch (e) {
        console.warn('Push notification registration failed:', e);
      }
    };

    const timer = setTimeout(registerPush, 3000);
    return () => clearTimeout(timer);
  }, [user]);

  useEffect(() => {
    if (!user) return;
    let unsubscribe = () => {};
    import('@/lib/firebase').then(({ onForegroundMessage }) => {
      unsubscribe = onForegroundMessage((payload) => {
        const title = payload.notification?.title || 'New Notification';
        const body = payload.notification?.body || '';
        toast(title, { description: body, duration: 6000 });
      });
    }).catch(() => {});
    return () => unsubscribe();
  }, [user]);

  return null;
}
